var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMilkCup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.78357 5.6156C7.2186 5.61882 7.54546 5.71727 7.93884 5.85193C8.33201 5.98652 8.81603 6.16795 9.44958 6.23279C10.0313 6.29226 10.7551 6.27859 11.3109 6.2533C11.3778 6.25025 11.4427 6.24492 11.5052 6.24158L10.7738 13.5668C10.7427 13.8761 10.5086 14.1096 10.226 14.1429C8.71435 14.3202 7.5106 14.3272 5.78357 14.1351C5.49436 14.103 5.25716 13.866 5.22595 13.5551L4.48083 6.11462C4.6333 6.06215 4.8148 6.003 5.01306 5.94373C5.60639 5.76637 6.28242 5.61196 6.78357 5.6156ZM4.88416 2.11853C7.12785 2.26783 8.85181 2.28512 11.101 2.13025C11.5371 2.10043 11.8833 2.46473 11.8422 2.87634L11.64 4.89783C11.5223 4.90513 11.3908 4.91585 11.2504 4.92224C10.7064 4.947 10.0643 4.95558 9.58533 4.90662C9.13167 4.86019 8.79681 4.73615 8.37048 4.59021C7.94457 4.44441 7.45085 4.28744 6.79333 4.28259C6.08181 4.27742 5.24538 4.4828 4.63123 4.66638C4.53131 4.69625 4.43574 4.72709 4.34509 4.75623L4.15564 2.85876C4.1146 2.44838 4.45698 2.0902 4.88416 2.11853Z",
    stroke: "#7F7F84",
    strokeWidth: 1.33333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilkCup);
export default __webpack_public_path__ + "static/media/milk-cup.efc7cceba7bfe47e6b7e2407162c5518.svg";
export { ForwardRef as ReactComponent };